module.exports = __webpack_public_path__ + "static/media/ccg-logo.994fe1df.svg";